@if (isEnabled$ | async) {
  @if (patientLink$ | async; as patientLink) {
    <a
      class="w-full flex-1"
      target="_blank"
      mat-stroked-button
      [href]="patientLink"
    >
      <div class="flex items-center gap-2">
        <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
        <span>Create Prescription via Parchment</span>
        <mat-icon>open_in_new</mat-icon>
      </div>
    </a>
  } @else {
    @if (validationErrors$ | async; as errors) {
      <div [matTooltip]="errors">
        <button mat-stroked-button class="flex-1" disabled>
          <div class="flex items-center gap-2">
            <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
            <span>Create Prescription via Parchment</span>
            <mat-icon color="warn">warning</mat-icon>
          </div>
        </button>
      </div>
    } @else {
      <div [matTooltip]="syncingPatientTooltip()">
        <pt-loader-button
          class="flex-1"
          type="stroked"
          [loading]="isLoading()"
          [disabled]="true"
        >
          <div class="ml-2 flex items-center gap-2">
            <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
            <span>Syncing patient with Parchment</span>
          </div>
        </pt-loader-button>
      </div>
    }
  }
} @else {
  <div class="flex flex-1 flex-col gap-4">
    <button
      #overlayTarget="cdkOverlayOrigin"
      cdkOverlayOrigin
      class="flex-1 rounded border border-solid border-gray-300 bg-transparent px-4 py-[5px] font-semibold hover:bg-gray-100"
    >
      <div class="flex items-center gap-2">
        <img class="h-6 w-6" src="/assets/integrations/parchment.png" />
        Enable ePrescriptions via Parchment
      </div>
    </button>
  </div>

  <pt-custom-tooltip [target]="overlayTarget" [positions]="positions">
    <ng-template ptCustomTooltipContent>
      <div class="m-2">
        <pr-parchment-marketing-tooltip />
      </div>
    </ng-template>
  </pt-custom-tooltip>
}
